var map = {
	"./add-image.svg": 3794,
	"./book.svg": 3914,
	"./love_hollow.svg": 3129,
	"./love_solid.svg": 4181,
	"./proportion.svg": 8999,
	"./star.svg": 8637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;